import React, { useState } from 'react'
import { Button, Col, Row, Card, CardBody } from 'reactstrap';
import { IndexSearchQuoter } from './IndexSearchQuoter';
import { buap } from '../../../constant/globalConstantsTypeClients';
import '../../quoter/styleQuoters/styleHeaderquoter.css'
import '../../quoter/styleQuoterClinicMovil/styleHeaderMovilClinics.css'

export const IndexHederQuoter = (props) => {
    const {
        // ? SEARCH GLOBAL QUOTER
        setSelectedCompany, selectedCompany, handleSelectExamChange,
        chekTypeClient,handleSelectValues, listQuoterTest, 
        clearQuotationTests, viewQuoter, resetQuotationForAgreement,

        // ? TABS 
        requestChangeType, url_helen,  activeView,

        //? SIDEBAR
        setRightPanelOpen


    } = props

    const [showMobileFilters, setShowMobileFilters] = useState(false);

    return (
        <>        
        
            {/* <Row className="pos-header-row align-items-center"> */}
            <Row className="quoter-header-row d-none d-md-flex">

                <Col
                    xs="12"
                    lg={activeView === 0 ? "12" : "auto"}
                    className="quoter-header-block header-buttons"
                >
                    <div
                        className={
                            activeView === 0
                                ? "full-tabs-quoter-clinics"
                                : "quoter-tabs"
                        }
                    >
                        <Button
                            size="sm"
                            onClick={() => requestChangeType(0, 0)}
                            className={`pos-pill-tab-quoter-clinics ${activeView === 0 ? "active" : ""
                                }`}
                        >
                            <i className="icofont icofont-search"></i>
                            Buscar Cotización
                        </Button>

                        <Button
                            size="sm"
                            onClick={() => requestChangeType(1, 1)}
                            className={`pos-pill-tab-quoter-clinics ${activeView === 1 ? "active" : ""
                                }`}
                        >
                            <i className="icofont icofont-user-alt-5"></i>
                            Particular
                        </Button>

                        {url_helen !== buap && chekTypeClient !== 2 && (
                            <Button
                                size="sm"
                                onClick={() => requestChangeType(2, 3)}
                                className={`pos-pill-tab-quoter-clinics ${activeView === 2 ? "active" : ""
                                    }`}
                            >
                                <i className="icofont icofont-industries-alt-4"></i>
                                Empresa
                            </Button>
                        )}
                    </div>
                </Col>

                {
                    activeView !== 0 && (
                        <Col
                            xs="12"
                            lg
                            className="px-2 header-block header-search"
                        >
                            <div className="input-group-dark">

                                <div
                                    className={`quoter-search-container ${viewQuoter ? "search-disabled" : ""
                                        }`}
                                >

                                    <IndexSearchQuoter
                                        setSelectedCompany={setSelectedCompany}
                                        selectedCompany={selectedCompany}
                                        handleSelectExamChange={handleSelectExamChange}
                                        chekTypeClient={chekTypeClient}
                                        handleSelectValues={handleSelectValues}
                                        listQuoterTest={listQuoterTest}
                                        clearQuotationTests={clearQuotationTests}
                                        disabled={viewQuoter}
                                        resetQuotationForAgreement={resetQuotationForAgreement}
                                    />

                                </div>

                            </div>
                        </Col>
                    )
                }

                <Col
                    xs="12"
                    lg="auto"
                    className="d-flex justify-content-end pl-0 header-block header-menu mobile-only"
                >
                    <div className="quoter-icon-toggle">
                        <i className="fa fa-bars"></i>
                    </div>
                </Col>
            </Row>

            {/* MOBILE HEADER */}
            <Row className="quoter-mobile-header-row d-flex d-md-none">
                {
                    activeView === 0 ? (

                        <Col xs="12" className="p-0">
                            <div className="quoter-mobile-tabs-list">

                                <Button
                                    size="sm"
                                    onClick={() => requestChangeType(0, 0)}
                                    className={`pos-pill-tab-quoter-clinics ${activeView === 0 ? "active" : ""
                                        }`}
                                >
                                    <i className="icofont icofont-search"></i>
                                    Listado
                                </Button>

                                <Button
                                    size="sm"
                                    onClick={() => requestChangeType(1, 1)}
                                    className={`pos-pill-tab-quoter-clinics ${activeView === 1 ? "active" : ""
                                        }`}
                                >
                                    <i className="icofont icofont-user-alt-5"></i>
                                    Particular
                                </Button>

                                {
                                    url_helen !== buap &&
                                    chekTypeClient !== 2 && (

                                        <Button
                                            size="sm"
                                            onClick={() => requestChangeType(2, 3)}
                                            className={`pos-pill-tab-quoter-clinics ${activeView === 2 ? "active" : ""
                                                }`}
                                        >
                                            <i className="icofont icofont-industries-alt-4"></i>
                                            Empresa
                                        </Button>

                                    )
                                }

                            </div>

                        </Col>

                    ) : (

                        <>
                            {
                            showMobileFilters && (
                               <div className="quoter-mobile-extra-options">
                                    <Button
                                        className={`quoter-mobile-type-btn${activeView === 0 ? "active" : ""}`}
                                        onClick={() => requestChangeType(0,0)}
                                    >
                                        <i className="icofont icofont-search"></i>
                                        <span>Listado</span>
                                    </Button>

                                    <Button
                                        className={`quoter-mobile-type-btn ${activeView === 1 ? "active" : ""}`}
                                        onClick={() => requestChangeType(1,1)}
                                    >
                                        <i className="icofont icofont-user-alt-5"></i>
                                        <span>Particular</span>
                                    </Button>

                                    <Button
                                        className={`quoter-mobile-type-btn ${activeView === 2 ? "active" : ""}`}
                                        onClick={() => requestChangeType(2,3)}
                                    >
                                        <i className="icofont icofont-industries-alt-4"></i>
                                        <span>Empresa</span>
                                    </Button>

                                </div>
                            )
                        }

                        <div className="quoter-mobile-search-row">
                            <div className="quoter-mobile-top-actions">
                                <div
                                    className={`quoter-icon-toggle quoter-mobile-type-toggle ${showMobileFilters ? "active" : ""}`}
                                    onClick={() => setShowMobileFilters(!showMobileFilters)}
                                >
                                    <i
                                        className={
                                            showMobileFilters
                                                ? "icofont icofont-close-line"
                                                : "fa fa-th-large"
                                        }
                                    ></i>
                                </div>
                            </div>
                            
                            <div className="quoter-search-container">
                                <IndexSearchQuoter
                                    setSelectedCompany={setSelectedCompany}
                                    selectedCompany={selectedCompany}
                                    handleSelectExamChange={handleSelectExamChange}
                                    chekTypeClient={chekTypeClient}
                                    handleSelectValues={handleSelectValues}
                                    listQuoterTest={listQuoterTest}
                                    clearQuotationTests={clearQuotationTests}
                                    disabled={viewQuoter}
                                    resetQuotationForAgreement={resetQuotationForAgreement}
                                />
                            </div>

                            <div className="quoter-mobile-top-actions">
                                <div
                                    className="quoter-icon-toggle f-20"
                                    onClick={() => setRightPanelOpen(true)}
                                >
                                    <i className="fa fa-bars"></i>
                                </div>
                            </div>

                        </div>

                        </>

                    )
                }

            </Row>
            
        </>
    )
}
